import { render, staticRenderFns } from "./BranchFormContent.vue?vue&type=template&id=12342cf1&scoped=true"
import script from "./BranchFormContent.vue?vue&type=script&lang=js"
export * from "./BranchFormContent.vue?vue&type=script&lang=js"
import style0 from "./BranchFormContent.vue?vue&type=style&index=0&id=12342cf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12342cf1",
  null
  
)

export default component.exports